import create from 'zustand'

type UseZendeskStore = {
  isVisible: boolean
  setIsVisible: (value: boolean) => void
}

export const useZendeskStore = create<UseZendeskStore>(set => ({
  isVisible: false,
  setIsVisible: (value: boolean) => {
    set(() => ({
      isVisible: value,
    }))
  },
}))
